import environment from 'environment'


const url = environment.BACKEND_BASE_URL
const moralisAPI = environment.REACT_APP_MORALIS_API_PATH
const openSeaAPI = environment.REACT_APP_OPENSEA_API_PATH

export const APIPath = {
    openSeaAPI,
    moralisAPI,

  
    assets: 'assets',



    chartData:
        'https://api.coingecko.com/api/v3/coins/totem-earth-systems/market_chart',
}
